// extracted by mini-css-extract-plugin
export default {"qrCodeContainer":"QrGenerator_qrCodeContainer__cuSq+","qrCode":"QrGenerator_qrCode__M7TYP","qrCodeGenerator":"QrGenerator_qrCodeGenerator__xp78Z"};